export default "__VITE_ASSET__12b2cdb4__"